import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceBehfaRef_Interface } from 'src/app/Interface/DeviceBehfaRef_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceBehfaRefService {

  constructor(private http: HttpClient) { }


  GetRecord(Token: String,
    PeriodDate: number,
    status: number,
    Familly: String,
    Behfacode: String,
    StartSearchDate: String,
    EndSearchDate: String): Observable<Array<DeviceBehfaRef_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaRef?token=" + Token
      + "&PeriodDate=" + PeriodDate
      + "&status=" + status
      + "&Familly=" + Familly
      + "&Behfacode=" + Behfacode
      + "&StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
    ).pipe(
      map(data => {
        return data as Array<DeviceBehfaRef_Interface>
      }))
  }

  GetSingle(Token: String,
    id: number): Observable<DeviceBehfaRef_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaRef/GetSingle?token=" + Token
      + "&id=" + id).pipe(
      map(data => {
        return data as DeviceBehfaRef_Interface
      }))
  }

  SubmitReuqest(Token: String,
    file_id: number,
    dsc: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaRef/SubmitReuqest?token=" + Token
      + "&file_id=" + file_id
      + "&dsc=" + dsc).pipe(
      map(data => {
        return data as any
      }))

  }


}
